// EntityType is a string identifier from the backend (e.g., "PaymentTransactionType", "Patient").
// The backend API provides both the type identifier and display name, so no frontend mapping is needed.
// If the backend sends numeric enum values instead of strings, that's a backend serialization
// configuration issue (needs JsonStringEnumConverter in C#) - don't work around it here.
export type EntityType = string;

// Constant for the unknown/invalid entity type fallback
export const UNKNOWN_ENTITY_TYPE = "Unknown";

export enum SyncScheduleType {
    Initial = 0,
    OneTime,
    Recurring,
    EgressOnly,
    EgressOnlyForNewEnrollment,
    PurgeChangeQueue,
}
